import { render, staticRenderFns } from "./BoxSectionMenu.vue?vue&type=template&id=4fe61c3d&scoped=true&"
import script from "./BoxSectionMenu.vue?vue&type=script&lang=js&"
export * from "./BoxSectionMenu.vue?vue&type=script&lang=js&"
import style0 from "./BoxSectionMenu.vue?vue&type=style&index=0&id=4fe61c3d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe61c3d",
  null
  
)

export default component.exports